"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyState = exports.svgNames = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var allowedIcons = __importStar(require("../../styles/svg"));
var Button_1 = __importDefault(require("../Button"));
var Flex_1 = __importDefault(require("../Flex"));
var EmptyStateBody_1 = __importDefault(require("./components/EmptyStateBody"));
var EmptyStateIcon_1 = __importDefault(require("./components/EmptyStateIcon"));
var EmptyStateText_1 = __importDefault(require("./components/EmptyStateText"));
var EmptyStateTitle_1 = __importDefault(require("./components/EmptyStateTitle"));
exports.svgNames = [
    "sloth",
    "box",
    "girl",
    "cactus",
    "calendar",
    "calendar2",
    "bell",
    "barChart",
    "flower",
    "ghost",
    "guard",
    "kite",
    "lightbulb",
    "magnifier",
    "movie",
    "pig",
    "documents"
];
exports.StyledEmptyState = styled_components_1.default(Flex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  min-width: 0;\n  word-wrap: break-word;\n  -webkit-background-clip: border-box;\n  background-clip: border-box;\n"], ["\n  position: relative;\n  min-width: 0;\n  word-wrap: break-word;\n  -webkit-background-clip: border-box;\n  background-clip: border-box;\n"])));
var EmptyState = function (_a) {
    var icon = _a.icon, emptyStateTitle = _a.emptyStateTitle, children = _a.children, button = _a.button, titleSize = _a.titleSize, props = __rest(_a, ["icon", "emptyStateTitle", "children", "button", "titleSize"]);
    return (react_1.default.createElement(exports.StyledEmptyState, __assign({}, props, { textAlign: "center" }),
        react_1.default.createElement(EmptyStateBody_1.default, null,
            icon && react_1.default.createElement(EmptyStateIcon_1.default, null, allowedIcons[icon]),
            emptyStateTitle && (react_1.default.createElement(EmptyStateTitle_1.default, { size: titleSize }, emptyStateTitle)),
            react_1.default.createElement(EmptyStateText_1.default, null, children),
            button && react_1.default.createElement(Button_1.default, __assign({}, button, { color: "primary" })))));
};
exports.default = EmptyState;
var templateObject_1;
//# sourceMappingURL=index.js.map